import "./instrument";
import { createRoot } from "react-dom/client";
import { Sentry } from "./instrument";
import App from "./App";
import "./index.css";
import "./workspace-theme.css";
import { bootstrapImpersonation } from "./lib/impersonation";

// v7.54 — admin "Login as user": must run before any fetch so this tab's
// requests carry the impersonation token (no-op in a normal tab).
bootstrapImpersonation();


createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary
    fallback={({ resetError }) => (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-8 text-center">
        <h1 className="text-xl font-semibold">Something went wrong</h1>
        <p className="text-sm text-muted-foreground max-w-md">
          The error has been reported. Try reloading the page.
        </p>
        <button
          className="px-4 py-2 rounded-md bg-indigo-600 text-white text-sm"
          onClick={() => {
            resetError();
            window.location.reload();
          }}
        >
          Reload
        </button>
      </div>
    )}
  >
    <App />
  </Sentry.ErrorBoundary>,
);
